module.exports = __webpack_public_path__ + "img/mpk-clems-stocking-list-thumb.184a13a5.png";